import { render, staticRenderFns } from "./MainSideBar.vue?vue&type=template&id=6b06c4e9&scoped=true&"
import script from "./MainSideBar.vue?vue&type=script&lang=js&"
export * from "./MainSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MainSideBar.vue?vue&type=style&index=0&id=6b06c4e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06c4e9",
  null
  
)

export default component.exports